import { User } from "../store";

export default () => `
<!------------- header--------------->
<div class="main-header">
    <div class="header">
        <h6>
            return free on all orders
        </h6>
        <h6>
            free shipping on all order $50+
        </h6>
    </div>
    `;
